export default __webpack_public_path__ + "static/media/Nav-Registration active.899dfbbe.svg";